import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { MatSnackBar } from '@angular/material';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { UserService } from '../user/user.service';
import { IEntity } from '../models/entity.model';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent {
  // galleryImages: NgxGalleryImage[];
  selectedImage: string;
  selectedFile: File;
  completedFiles: string[];
  statusPercent = '';
  uploadDisabled = true;
  uploading = false;
  imageType = 'business';

  constructor(public dialogRef: MatDialogRef<ImageUploadComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _snackBar: MatSnackBar,
              private _http: HttpClient,
              private _userService: UserService) {
    this.completedFiles = [];
  }

  onFileChanged(event) {
    const snackBarOpts = {duration: 6000};
    this.selectedFile = event.target.files[0];
    if (!this.selectedFile) {
      this.uploadDisabled = true;
      return;
    }
    if (this.selectedFile && this.selectedFile.size > 99999999) {
      this._snackBar.open('Image must be 10 MB or less in size.', 'Dismiss', snackBarOpts);
      return;
    }
    if (this.selectedFile && !['image/jpeg', 'image/png', 'image/tiff'].includes(this.selectedFile.type)) {
      this._snackBar.open('Image must be a jpg, png, or tif file.', 'Dismiss', snackBarOpts);
      return;
    }
    this.uploadDisabled = false;
  }

  onUpload() {
    if (this.data.images.length > 2) {
      const snackBarOpts = {duration: 6000};
      this._snackBar.open('Only three images are allowed.', 'Dismiss', snackBarOpts);
      return;
    }

    this.uploading = true;
    let addNullstring = '';
    const uploadData = new FormData();
    if (this.data.entity.type === 'Airport') {
      uploadData.set('airportId', this.data.entity.id);
      uploadData.set('category', 'AirportReview');
      this.imageType = 'airport';
      addNullstring = '/null';
    } else if (this.data.entity.type === 'Event') {
      uploadData.set('eventId', this.data.entity.id);
      uploadData.set('category', 'event');
      this.imageType = 'event';
    } else {
      uploadData.set('businessId', this.data.entity.id);
      uploadData.set('category', 'BusinessReview');
      addNullstring = '/null';
    }
    // uploadData.set(this.selectedFile.name, this.selectedFile.name);
    uploadData.append('File', this.selectedFile, this.selectedFile.name);
    const contentDisposition = 'form-data; name="' + this.selectedFile.name + '"; filename="' + this.selectedFile.name + '"';
    this._http.post(`${environment.airportsApiUrl}/photos/` + this.imageType + '/upload' + addNullstring, uploadData, {headers: {
        'Content-Disposition': contentDisposition
      },
      reportProgress: true,
      observe: 'events'
    })
    // this._userService.postAirportReviewPhoto( , this.selectedFile, )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          this.statusPercent = percentDone.toString();
        } else if (event instanceof HttpResponse) {
          this.uploadDisabled = true;
          this.uploading = false;
          if (event.status && event.status === 200 && event.body) {
            this.completedFiles.push(this.selectedFile.name);
            // @ts-ignore
            this.data.newPhotoIds.push(event.body.photoId);
            const imageObject = {
              small: '',
              medium: '',
              big: ''
            };
            // @ts-ignore
            imageObject.small = event.body.thumbnailPhotoPath;
            // @ts-ignore
            imageObject.medium = event.body.previewPhotoPath;
            // @ts-ignore
            imageObject.big = event.body.largePhotoPath;
            this.data.images.push(imageObject);
          }
        }
      });
  }

  onAddImage(): void {
    if (this.data.images.length > 2) {
      const snackBarOpts = {duration: 6000};
      this._snackBar.open('Only three images are allowed.', 'Dismiss', snackBarOpts);
      return;
    }
    const imageObject = {
      small: this.selectedImage,
      medium: this.selectedImage,
      big: this.selectedImage
    };
    this.data.images.push(imageObject);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
